import type { Cng, Tone } from '../types/domain';

export function verifyStatus(stage: number, cng?: Cng): { label: string; tone: Tone } {
  if (cng && cng.brtaStatus === 'অমিল' && stage <= 1) return { label: 'তথ্যগত সমস্যা', tone: 'red' };
  switch (stage) {
    case 0:
      return { label: 'খসড়া', tone: 'gray' };
    case 1:
      return { label: 'যাচাই অপেক্ষমাণ', tone: 'orange' };
    case 2:
      return { label: 'পর্যালোচনাধীন', tone: 'blue' };
    case 3:
      return { label: 'অনুমোদনের অপেক্ষায়', tone: 'orange' };
    case 4:
    case 5:
    case 6:
      return { label: 'অনুমোদিত', tone: 'blue' };
    default:
      return { label: 'সক্রিয়', tone: 'green' };
  }
}

export function qrStatus(stage: number): { label: string; tone: Tone } {
  if (stage >= 7) return { label: 'ইস্যুকৃত', tone: 'green' };
  if (stage === 6) return { label: 'প্রিন্টকৃত', tone: 'blue' };
  if (stage === 5) return { label: 'তৈরিকৃত', tone: 'blue' };
  if (stage === 4) return { label: 'তৈরির অপেক্ষায়', tone: 'orange' };
  return { label: 'অপেক্ষমাণ', tone: 'orange' };
}

export function brtaTone(status: string): Tone {
  if (status === 'যাচাইকৃত') return 'green';
  if (status === 'অমিল') return 'red';
  return 'orange';
}

export function resultTone(result: string): Tone {
  if (result === 'বৈধ') return 'green';
  if (result === 'সমস্যা' || result === 'মেয়াদোত্তীর্ণ ডকুমেন্ট') return 'orange';
  return 'red';
}

export function caseTone(status: string): Tone {
  if (status === 'নতুন') return 'red';
  if (status === 'পর্যালোচনাধীন') return 'orange';
  if (status === 'ব্যবস্থা গ্রহণ করা হয়েছে') return 'blue';
  return 'green';
}
